// PageResetv2 Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import app from '../../../app.jsx'
import { logger } from '../../../lib/logging'
import ResetContentv2 from '../../login/reset_contentv2/reset_contentv2.jsx'
import DialogTeamSelect from '../../team/dialog_team_select/dialog_team_select.jsx'

class PageResetv2 extends Component {
  constructor (props) {
    super(props)

    this.state = {
      teams: [],
      resetEmail: null
    }

    this._references = {
      resetContent: React.createRef()
    }
  }

  static get propTypes () {
    return {
      token: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      token: ''
    }
  }

  componentDidMount () {
    this.getUserData()
  }

  render () {
    const { resetEmail } = this.state

    return (
      <div className='page-signup'>
        <ResetContentv2
          ref={this._references.resetContent}
          reset
          onReset={this.onReset.bind(this)}
          onRedirectLogin={() => app.redirect('/login')}
          resetEmail={resetEmail}
        />
        {this.renderTeamSelect()}
      </div>
    )
  }

  getUserData () {
    app
      .service('/api/userreset')
      .find({
        query: { token: this.props.token }
      })
      .then((result) => {
        this.setState({ resetEmail: result.data[0].email })
      })
      .catch(error => {
        if (this._references.resetContent.current) {
          this._references.resetContent.current.showResetError()
        } else {
          logger.error(error)
        }
      })
  }

  /* Event handlers */
  onReset (email, password) {
    const data = { token: this.props.token, email: email, password: password }
    app
      .service('/api/page/reset')
      .create(data)
      .then((result) => {
        if (result) {
          if (result.bNoTeam) {
            if (this._references.resetContent.current) {
              this._references.resetContent.current.showResetSuccess()
            }
          } else {
            this.onLogin(email, password)
          }
        }
      })
      .catch(error => {
        if (this._references.resetContent.current) {
          this._references.resetContent.current.showResetError()
        } else {
          logger.error(error)
        }
      })
  }

  renderTeamSelect () {
    const { teams } = this.state

    if (teams.length > 0) {
      return (
        <DialogTeamSelect
          teams={this.state.teams}
          onSelect={this.onTeamSelect.bind(this)}
        />
      )
    }

    return null
  }

  onLogin (email, password) {
    if (this._references.resetContent.current) {
      this._references.resetContent.current.hideLoginError()
    }

    app.authentication.login({
      email,
      password
    }).then(({ availableTeams, activeTeam }) => {
      // If we have an active team, we redirect to the dashboard.
      if (activeTeam) {
        return app.redirect('/')
      }

      // Otherwise, we set the teams to the state so the team selector will be shown.
      this.setState({ teams: availableTeams })
    })
  }

  onTeamSelect (teamId) {
    return app.teamContext.switchToTeamById({ userId: app.userId, teamId }).then(() => {
      return app.redirect('/')
    })
  }
}

export default PageResetv2
